import React from 'react'
import { func } from 'prop-types'

class PromoModal extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      visible: true,
      promoCode: ''
    }
    this.hideModal = this.hideModal.bind(this)
    this.updateValue = this.updateValue.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  hideModal () {
    this.setState({
      visible: false
    })
  }

  updateValue (e) {
    this.setState({
      promoCode: e.target.value
    })
  }

  handleSubmit () {
    const { promoCode } = this.state
    if (promoCode === '') return window.alert('Please enter a promo code')
    this.props.updateAgent(promoCode)
    this.hideModal()
  }

  render () {
    const { visible, promoCode } = this.state
    if (!visible) return null
    return (
      <div>
        <div className='modal-backdrop in' onClick={this.hideModal} />
        <div role='dialog' aria-labelledby='PromoModalHeading' className='modal show' id='PromoModal'>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <button className='close' data-dismiss='modal' type='button' data-track-name='PromoModalCloseButton' data-track-value='clicked' onClick={this.hideModal}>×</button>
                <h4 className='modal-title' id='PromoModalHeading'>
                  Please enter your <strong>promo code</strong> for an <strong>instant discount</strong>...
                </h4>
              </div>
              <div className='modal-body clearfix'>
                <form className='promoForm clearfix col-xs-12' onSubmit={this.handleSubmit}>
                  <input className='form-control promoCodeInput' onChange={this.updateValue} type='text' name='promo_code' placeholder='Enter your promo code' value={promoCode} />
                </form>
              </div>
              <div className='modal-footer'>
                <div className='col-xs-12 col-sm-6'>
                  <a className='btn btn-block btn-default promoNoThanksBtn' href='#' data-track-name='PromoModalNoThanks' data-track-value='clicked' onClick={this.hideModal}>No thanks</a>
                </div>
                <div className='col-xs-12 col-sm-6'>
                  <a className='btn btn-block btn-primary promoApplyBtn' href='#' data-track-name='PromoModalApply' data-track-value='clicked' onClick={this.handleSubmit}>Apply Discount</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PromoModal.propTypes = {
  updateAgent: func
}

PromoModal.defaultProps = {
  updateAgent: () => {}
}

export default PromoModal
